import { render, staticRenderFns } from "./kong.vue?vue&type=template&id=1aedc34d&scoped=true&"
import script from "./kong.vue?vue&type=script&lang=js&"
export * from "./kong.vue?vue&type=script&lang=js&"
import style0 from "./kong.vue?vue&type=style&index=0&id=1aedc34d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aedc34d",
  null
  
)

export default component.exports